module.exports = __webpack_public_path__ + "../resources/images/illustration_attachment-25bc2ce6de72baeb30b21ee3954ac7a1.svg";